import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import ItemRemarks from '../ProfileCaseListItem/ItemRemarks'
import OpenForm from '../ProfileCaseListItem/OpenForm'
import caretRight from '../../icons/caret-right_light_gray.svg'
import caretRightActive from '../../icons/caret-right_gray.svg'
import { setActiveConnection, unsetActiveConnection } from '../../redux/actions'
import { getActiveConnectionDataFromClickedListItem } from '../ConnectionForm/utils'
import { getActiveConnection } from '../../redux/selectors'
import {
  RELATION_OWNERSHIP,
  RELATION_PUBLIC_DATA_OWNERSHIP,
  RELATION_ROLE,
  RELATION_PUBLIC_DATA_ROLE,
  RELATION_OTHER_CONNECTION
} from '../../connectionTypes'
import ownershipIcon from '../../icons/chartLine.svg'
import roleIcon from '../../icons/role.svg'
import indirectIcon from '../../icons/indirect.svg'
import otherIcon from '../../icons/other.svg'

import { StatusBadge } from '../../CaseStatus'
import { useI18nFunction } from '../I18n'
import { capitalize } from '../../utils'
import GoToCase, { CaseLink } from '../ProfileCaseListItem/GoToCase'


const RelationCaseListItem = ({
  Case,
  setActiveConnection,
  unsetActiveConnection,
  active,
  editable,
  selectedCases,
  toggleCase,
}) => {
  const title = Case.organizationName
  const I18nFunction = useI18nFunction()
  const getConnectionTypeAndIcon = () => {
    let connectionType
    let icon
    let description
    if (Case?.relationRole != null) {
      connectionType = RELATION_ROLE
      icon = roleIcon
      description = Case.relationRole.title
    }
    else if (Case?.relationPublicDataRole != null) {
      connectionType = RELATION_PUBLIC_DATA_ROLE
      icon = roleIcon
      description = Case.relationPublicDataRole.title
    }
    else if (Case?.relationOwnership != null) {
      connectionType = RELATION_OWNERSHIP
      icon = ownershipIcon
      description = I18nFunction({
        id: 'connection_list_item.ownership_description',
        stockCount: Case.relationOwnership.stockCount,
        shareType: Case.relationOwnership.shareType,
        stakePercentage: parseFloat(Case.relationOwnership.stakePercentage).toFixed(2)
      })

    }
    else if (Case?.relationPublicDataOwnership != null) {
      connectionType = RELATION_PUBLIC_DATA_OWNERSHIP
      icon = ownershipIcon
      description = I18nFunction({
        id: 'connection_list_item.ownership_description',
        stockCount: Case.relationPublicDataOwnership.stockCount,
        shareType: Case.relationPublicDataOwnership.shareType,
        stakePercentage: parseFloat(Case.relationPublicDataOwnership.stakePercentage).toFixed(2)
      })
    }
    else if (Case?.relationOtherConnection != null) {
      connectionType = RELATION_OTHER_CONNECTION
      icon = otherIcon
      description = Case?.relationOtherConnection?.title ||
       I18nFunction({ id: 'connection_list_item.other_description_fallback' })
    }

    if (Case?.caseType.toLowerCase().includes('indirect')) {
      icon = indirectIcon
      description = capitalize(I18nFunction({ id: "connection_form.headings.indirect_ownership" }))
    }
    return [connectionType, icon, description]
  }

  const [connectionType, listIcon, description] = getConnectionTypeAndIcon()


  const checked = !connectionType?.toLowerCase().includes('public')

  const onClick = (e) => {
    const activeConnectionData = getActiveConnectionDataFromClickedListItem(
      Case,
    )

    unsetActiveConnection()
    active
      ? unsetActiveConnection()
      : setActiveConnection({
        id: activeConnectionData.id,
        caseId: Case?.id,
        relationId: Case?.relationId,
        connectionType: connectionType,
        directConnectionCaseId: Case?.directConnectionCaseId,
        parentCaseId: Case?.parentCaseId,
        connection: activeConnectionData,
      })
  }

  return (
    <li>
      <Wrapper>
        {editable && <ToggleWrapper>
          <input
            type="checkbox"
            checked={!!selectedCases[Case.id]}
            onChange={() => {
              toggleCase(Case.id)
              unsetActiveConnection()
            }}
          />
        </ToggleWrapper>}
        <CaseNumber>
          #{Case?.id}
        </CaseNumber>
        <Description className={[
          active && 'active',
          !checked && 'attention',
          !!selectedCases[Case.id] && 'toggled',
          !editable && 'disabledInteraction',
        ]}
          onClick={onClick}>
          <Icon src={listIcon} alt="" />
          <Content>
            <Title small={true} title={title}>
              {title}
            </Title>
            <Subtitle>
              {description}
            </Subtitle>
          </Content>
          <RightFlexBox>
            <StatusWrapper>
              <StatusBadge status={Case?.status} />
            </StatusWrapper>
            <MarkerWrapper>
              <ItemRemarks Case={Case} confirmed={checked} />
            </MarkerWrapper>
            <Buttons>
              {checked && <GoToCase caseId={Case?.id} />}
              <OpenForm onClick={onClick} />
              <CaretRight src={active ? caretRightActive : caretRight} />
            </Buttons>
          </RightFlexBox>
        </Description>
      </Wrapper>
    </li>
  )
}
const Subtitle = styled.div`
  display: flex;
  flex-direction: row;
  color: ${({ theme: { subtleText } }) => subtleText};

`
const RightFlexBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 60%;
`

const StatusWrapper = styled.div`
  display: flex;
`

const MarkerWrapper = styled.div`
  margin-left: auto; 
  margin-right: 0;
`

const Buttons = styled.div`
  display: flex;
  margin-left: auto; 
  margin-right: 0;
  gap: 0.2em;
  padding: 0em 0.5em;
`

const CaretRight = styled.img`
`

const Content = styled.div`
  overflow: hidden;
  white-space: nowrap;
  width: 34%;
  padding-right: 0em;
`

const Wrapper = styled.div`
  min-width: 100%;
  position: relative;
  display: flex;
  align-items: center;
`

const ToggleWrapper = styled.div`
  display: flex;
  width: 4%;
  align-items: center;
`

const Description = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 96%;
  box-shadow: rgb(219 219 219) 0px 2px 5px;
  background-color: ${({ theme }) => theme.primaryBackground};
  padding: 0.8em;
  padding-left: 1em;
  padding-right: 1em;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.listItemHover};
  }
 &:has(${CaseLink}:nth-of-type(1):hover) {
    background-color: ${({ theme }) => theme.primaryBackground};
  }

  &.active {
    background-color: ${({ theme }) => theme.listItemHover};
  }
  &.attention {
  }
  &.disabledInteraction {
    background-color: ${({ theme }) => theme.primaryBackground};
  }
`

const CaseNumber = styled.div`
  width: 9%
  color: ${({ theme: { subtleText } }) => subtleText};  
`

const Icon = styled.img`
  margin-right: 1.5em;
  height: 2em;
  width: 2em;
  flex-shrink: 0;
`
const Title = styled.div`
  font-size: ${({ small, theme: { normalText, largeText } }) =>
    small ? normalText : largeText};
  ${({ title, theme: { secondary } }) => !title && 'color: ' + secondary}
  margin-bottom: 0.2em;
  overflow: hidden;
  text-overflow: ellipsis;
`

const mapStateToProps = (state, props) => {
  const activeConnection = getActiveConnection(state)
  const active = (activeConnection?.caseId === props.Case.id)
  return {
    active: active,
    activeConnection: activeConnection,
  }
}

const mapDispatchToProps = { setActiveConnection, unsetActiveConnection }

export default connect(mapStateToProps, mapDispatchToProps)(RelationCaseListItem)

